import Vue from 'vue';
import Moment from 'moment';
import i18n from '../lang/content.i18n';

export const MomentDate = Vue.filter('momentDate', (inputDate, format) => {
  if(!inputDate) return '';
  let date = Moment(inputDate);
  let strDate = Moment(inputDate).format(format);
  let today = Moment().endOf('day');
  let tomorrow = Moment().add(1, 'day').endOf('day');
  if (date < today) return i18n.t('common.today');
  if (date < tomorrow) return i18n.t('common.tomorrow');
  return strDate;
});